import axios from 'axios'

// API service functions
export const authAPI = {
  login: (credentials) => axios.post('/auth/login', credentials),
  register: (userData) => axios.post('/auth/register', userData),
  verify: () => axios.get('/auth/verify'),
  refresh: () => axios.post('/auth/refresh'),
  logout: () => axios.post('/auth/logout'),
  changePassword: (passwords) => axios.put('/auth/password', passwords),
}

export const userAPI = {
  getProfile: () => axios.get('/users/profile'),
  updateProfile: (data) => axios.put('/users/profile', data),
  getUsers: () => axios.get('/users'),
  deactivateUser: (id) => axios.put(`/users/${id}/deactivate`),
  activateUser: (id) => axios.put(`/users/${id}/activate`),
}

export const clientAPI = {
  getClients: () => axios.get('/clients'),
  getProfile: (clientId) => axios.get('/clients/profile', { params: { clientId } }),
  updateProfile: (data) => axios.put('/clients/profile', data),
  uploadFavicon: (file, clientId) => {
    const formData = new FormData()
    formData.append('favicon', file)
    if (clientId) formData.append('clientId', clientId)
    return axios.post('/clients/favicon', formData)
  },
  uploadLogo: (file, clientId) => {
    const formData = new FormData()
    formData.append('logo', file)
    if (clientId) formData.append('clientId', clientId)
    return axios.post('/clients/logo', formData)
  },
  getUsage: (clientId) => axios.get('/clients/usage', { params: { clientId } }),
  completeOnboarding: (clientId) => axios.post('/clients/onboarding/complete', { clientId }),
}

export const siteAPI = {
  getSites: () => axios.get('/sites'),
  getSite: (id) => axios.get(`/sites/${id}`),
  createSite: (data) => axios.post('/sites', data),
  updateSite: (id, data) => axios.put(`/sites/${id}`, data),
  publishSite: (id) => axios.post(`/sites/${id}/publish`),
  deleteSite: (id) => axios.delete(`/sites/${id}`),
  getVersions: (id) => axios.get(`/sites/${id}/versions`),
  restoreVersion: (id, versionId) => axios.post(`/sites/${id}/versions/${versionId}/restore`),
}

export const mediaAPI = {
  getMedia: (params) => axios.get('/media', { params }),
  uploadMedia: (files, clientId) => {
    const formData = new FormData()
    files.forEach(file => formData.append('files', file))
    if (clientId) formData.append('client_id', clientId)
    return axios.post('/media/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  updateMedia: (id, data) => axios.put(`/media/${id}`, data),
  deleteMedia: (id) => axios.delete(`/media/${id}`),
  getStats: () => axios.get('/media/stats'),
}

export const requestAPI = {
  getRequests: (params) => axios.get('/requests', { params }),
  getRequest: (id) => axios.get(`/requests/${id}`),
  createRequest: (data) => axios.post('/requests', data),
  updateRequest: (id, data) => axios.put(`/requests/${id}`, data),
  deleteRequest: (id) => axios.delete(`/requests/${id}`),
  getStats: () => axios.get('/requests/stats/overview'),
}

export const billingAPI = {
  getBilling: (clientId) => axios.get('/billing', { params: { clientId } }),
  subscribe: (data) => axios.post('/billing/subscribe', data),
  cancelSubscription: (clientId) => axios.post('/billing/cancel', { clientId }),
  getInvoices: () => axios.get('/billing/invoices'),
  getOverview: () => axios.get('/billing/overview'),
}

export const analyticsAPI = {
  getSiteAnalytics: (siteId, period) => axios.get(`/analytics/site/${siteId}`, { 
    params: { period } 
  }),
  getOverview: (clientId) => axios.get('/analytics/overview', { 
    params: { clientId } 
  }),
  setupTracking: (siteId, data) => axios.post(`/analytics/setup/${siteId}`, data),
  compareSites: (siteIds) => axios.get('/analytics/compare', { 
    params: { siteIds: siteIds.join(',') } 
  }),
}

export const notificationAPI = {
  getNotifications: (params) => axios.get('/notifications', { params }),
  markAsRead: (id) => axios.patch(`/notifications/${id}/read`),
  markAllAsRead: () => axios.patch('/notifications/mark-all-read'),
  getUnreadCount: () => axios.get('/notifications/unread-count'),
  deleteNotification: (id) => axios.delete(`/notifications/${id}`),
}

export const domainAPI = {
  getDomains: () => axios.get('/domains'),
  addDomain: (data) => axios.post('/domains', data),
  updateDomain: (id, data) => axios.put(`/domains/${id}`, data),
  deleteDomain: (id) => axios.delete(`/domains/${id}`),
}

// Generic API service (used by newer components)
export const apiService = {
  get: (url, config) => axios.get(url, config),
  post: (url, data, config) => axios.post(url, data, config),
  put: (url, data, config) => axios.put(url, data, config),
  patch: (url, data, config) => axios.patch(url, data, config),
  delete: (url, config) => axios.delete(url, config),
}